<template>
	<div class="work-order disable-shortcut-key" style="display: flex; flex-direction: column; padding: 0;">
		<div class="list-container">
			<template v-if="ticketList.length">
				<div :class="{'section-block': true, open: item.open}" v-for="item in ticketList">
					<div class="section-head" @click="openTicket(item)">{{dateFormat(item.createTime, 'yyyy-MM-dd')}}创建<span class="el-icon-arrow-down icon-btn"></span></div>
					<div class="section-cont">
						<div class="info-box">
							<div class="row">
								<label class="label">用户电话：</label>
								<span class="cont">{{userPhone}}</span>
							</div>
							<div class="row">
								<label class="label">订单ID：</label>
								<span class="cont">{{item.diyOrderId}}</span>
							</div>
							<div class="row">
								<label class="label">处理人：</label>
								<span class="cont">{{item.dealUserName}}</span>
							</div>
							<div class="row">
								<label class="label">工单状态：</label>
								<span class="cont">{{ticketStatusList.find(o => o.value == item.orderStatus).name}}</span>
							</div>
							<div class="row" style="flex-wrap: wrap;">
								<label class="label">问题描述：</label>
								<div class="cont" style="white-space: pre-wrap; flex: auto;" v-html="item.orderContent"></div>
							</div>
						</div>
						<div class="flow-box">
							<dl v-for="(pItem, i) in item.processingRecords">
								<dt class="flex a-c j-sb">
									<span class="sign">{{ i + 1 }}</span>
									<span class="name">{{pItem.dealUserName}}</span>
									<span class="time">{{dateFormat(pItem.createTime, 'yyyy-MM-dd hh:mm:ss')}}</span>
								</dt>
								<dd>{{pItem.operateContent}}<span v-if="pItem.orderRemark && pItem.orderRemark.contentSummary">：{{pItem.orderRemark.contentSummary}}</span></dd>
							</dl>
						</div>
						<div class="reply-box">
							<div class="title">回复</div>
							<el-form>
								<el-form-item>
									<el-input v-model="item.replyContent" type="textarea"></el-input>
								</el-form-item>
								<div class="flex a-c j-sb">
									<el-form-item label="指派：" class="short-form-item">
										<queryTjkUserSelect v-model="item.dealUserId" @change="updateHandleUser($event, item)" />
									</el-form-item>
									<el-form-item label="状态：" class="short-form-item">
										<el-select v-model="item.orderStatus" placeholder="请选择" size="mini" @change="updateTicketStatus($event, item)">
											<el-option v-for="(option, i) in ticketStatusList" :key="i" :label="option.name" :value="option.value" />
										</el-select>
									</el-form-item>
								</div>
								<el-button type="primary" size="mini" style="width: 100%" @click="replyTicket(item)">回复</el-button>
							</el-form>
						</div>
					</div>
				</div>
			</template>
			<p v-else style="padding: 20px 0; text-align: center;">没有相关数据！</p>
			<div v-if="total > ticketList.length" style="text-align: center;">
				<span :class="{loading: loading}" style="color: #999; cursor: pointer;" @click="getTicketList(userPhone, currpage + 1)">查看更多</span>
			</div>
		</div>
		<div class="add-btn-box">
			<el-button type="primary" size="mini" style="width: 100%" @click="showCreateTicketDialog">创建工单</el-button>
		</div>

		<el-dialog title="创建工单" :visible.sync="createTicketObj.show" width="500px" :close-on-click-modal="false">
			<el-form :model="createTicketObj" ref="addFormBox" label-width="80px" size="mini" style="margin: -20px 0 -25px">
				<el-form-item label="用户电话：">{{userPhone}}</el-form-item>
				<el-form-item label="销售渠道：">{{channel}}</el-form-item>
				<el-form-item label="订单ID：" prop="orderNo" :rules="[{ required: true, message: '请输入订单ID', trigger: 'blur' }]">
					<el-input v-model="createTicketObj.orderNo" placeholder="最多100字" maxlength="100"></el-input>
				</el-form-item>
				<el-form-item label="工单分类：">
					<el-cascader v-model="createTicketObj.type" :options="ticketTypeList.children || []" :props="{value: 'id', label: 'name'}" change-on-select placeholder="请选择类别"></el-cascader>
				</el-form-item>
				<el-form-item label="紧急程度：">
					<el-select v-model="createTicketObj.priority" placeholder="请选择类别">
						<el-option v-for="(o, i) in priorityList" :key="i" :label="o.name" :value="o.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="供应商：" prop="supplier" :rules="[{ required: true, message: '请选择供应商', trigger: 'click' }]">
					<el-select v-model="createTicketObj.supplier" placeholder="请选择供应商">
						<el-option v-for="(o, i) in supplierList" :key="i" :label="o" :value="o"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="处理人：">
					<queryTjkUserSelect v-model="createTicketObj.dealUserId" />
				</el-form-item>
				<el-form-item label="问题描述：">
					<el-input v-model="createTicketObj.orderContent" type="textarea" :rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createTicketObj.show = false">取 消</el-button>
				<el-button type="primary" :loading="createTicketObj.loading" @click="createTicket()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import qs from 'qs'
import queryTjkUserSelect from './queryTjkUserSelect.vue'
export default {
	components: { queryTjkUserSelect },
	data () {
		return {
			userPhone: null,
			channel: null,
			ticketList: [],
			ticketStatusList: [],
			createTicketObj: {
				show: false,
				orderNo: null,
				type: null,
				priority: null,
				dealUserId: null,
				orderContent: null,
				loading: false,
				supplier: null
			},
			priorityList: [],
			ticketTypeList: {},
			loading: false,
			currpage: 0,
			total: 0,
			supplierList: ['去惠购商家','京东慧采','海任航','盈顺通','佳合泰','龙翔通讯','嗨呗可','富宸瑞','翠源商贸','益合广盛','省供销','元祖','美瑞通','中国石油四川岷江销售分公司','四川销售油料分公司','中国石油四川南充销售分公司','中国石油四川凉山销售分公司','爱达乐','华伟通讯','千行供应链','鑫锐意','北京一击','都市拓汇达','佳合泰','斯特雅','好客蜀韵','得力','欧菲斯','成都京东世纪贸易有限公司','史泰博','凉山惠乔生物','好客秦味','亿翔（琼珠）','得力','西安讯蓝工贸有限公司','陕西宏华石油装备科技有限公司','西安汉高商贸有限公司','得力（供应链）','优雅','绿万家','地球第三极','远中商贸','九寨沟高原食品','鑫链佳','稼中花','天山老巴依','卜蜂（正大）','成渝高速公路广告','阿坝青牧','蜀茶秦巴茗兰','众焰贸易','雅安建昌茶业','玉峰山水','食堂供应','四川新川蒲食品','云霞科技','藏地源','蜀厦实业','成都青旅']
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		}
	},
	props: {
		extInfos: {
			type: Array,
			default: () => []
		}
	},
	mounted () {
		let obj = this.extInfos.find(o => o.name === 'qxjike_user_id') || {}
		this.getUserPhone(obj.value).then(phone => {
			this.userPhone = phone
			this.getTicketList(phone)
		})
		this.getTicketStatusList()
		this.getTicketPriority()
		this.getTicketTypeList(90022, this.ticketTypeList)
		let obj1 = this.extInfos.find(o => o.name === 'qxjike_channel') || {}
		this.channel = obj1.value
	},
	methods: {
		// 获取工单状态列表
		getTicketStatusList() {
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketStatusApi.listCached').then(result => {
				if (result.status) {
					this.ticketStatusList = result.data
				} else {
					this.$message.error('获取工单状态列表失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('获取工单状态列表失败，错误码(' + response + ')');
			})
		},

		// 获取工单列表
		getTicketList(phone, currpage) {
			if (!phone) return
			let data = {
				viewId: 17,
				filter: {
					$and: [
						{
							$or: [ {$is_null: "orderStatus"}, {$in: {orderStatus: [2, 3, 5]}} ]
						},
						{
							$ticket_tag_like: `%${phone}%`
						}
					]
				},
				page: {
					pageNumber: currpage || 1,
					pageSize: 20
				}
			}
			this.loading = true
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketApi.list', data).then(result => {
				this.loading = false
				if (result.status) {
					this.currpage = data.page.pageNumber
					this.total = result.data.recordCount
					let arr = this.ticketList.filter(o => o.open).map(o => o.orderId)
					this.ticketList = this.currpage === 1 ? result.data.list : [...this.ticketList, ...result.data.list]
					for (let i = 0; i < this.ticketList.length; i++) {
						let item = this.ticketList[i]
						if (arr.includes(item.orderId)) {
							this.openTicket(this.ticketList[i])
						}
					}
				} else {
					this.$message.error('获取工单列表失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.loading = false
				this.$message.error('获取工单列表失败，错误码(' + response + ')');
			})
		},

		// 获取用户手机号
		getUserPhone(userId) {
			return new Promise((resolve, reject) => {
				let data = { userId }
				this.$axios.post(API_ROOT.url + '/QxJiKeApi.queryUserInfo', data).then(res => {
					if (res.status) {
						let o = res.data || {}
						resolve(o['客户电话'])
					} else {
						this.$message.error('获取用户手机号失败，失败原因：' + (result.msg || result.message));
						reject()
					}
				}, err => {
					this.$message.error('获取用户手机号失败，错误码(' + err + ')');
					reject()
				})
			})
		},

		// 打开工单
		openTicket(item) {
			this.$set(item, 'open', !item.open)
			if (!item.open) {
				return
			}
			this.getOrderId(item.orderId).then(id => this.$set(item, 'diyOrderId', id))
			this.getProcessingRecords(item)
		},

		// 获取订单ID
		getOrderId(ticketNo) {
			return new Promise((resolve, reject) => {
				let data = {ticketNo}
				this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketWorkflowApi.listFirstFormPropertyByTicketNo', data).then(result => {
					if (result.status) {
						let obj = (result.data || []).find(o => o.id === 'order_no')
						resolve(obj ? obj._value : null)
					} else {
						this.$message.error('获取订单ID失败，失败原因：' + (result.msg || result.message));
						reject()
					}
				}, err => {
					this.$message.error('获取订单ID失败，错误码(' + err + ')');
					reject()
				})
			})
		},

		// 获取处理记录
		getProcessingRecords(item) {
			let data = {
				ticketNo: item.orderId,
				page: {
					pageSize: 9999,
					orderBy: '`flow_id` DESC'
				}
			}
			if (item.dealUserId) {
				this.getProcessingUserName(item.dealUserId).then(res => {
					this.$set(item, 'dealUserName', res.name)
				})
			}
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketEventApi.listByTicketNo', data).then(result => {
				if (result.status) {
					let ids = result.data.list.map(o => o.dealUserId)
					this.getProcessingUserName(ids).then(users => {
						for (let i = 0; i < result.data.list.length; i++) {
							let item = result.data.list[i]
							let obj = users.find(o => o.id === item.dealUserId) || {}
							item.dealUserName = obj.name
						}
						this.$set(item, 'processingRecords', result.data.list)
					})
				} else {
					this.$message.error('获取处理记录失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('获取处理记录失败，错误码(' + response + ')');
			})
		},

		// 获取处理人姓名
		getProcessingUserName (ids) {
			let isArr = Array.isArray(ids)
			if (!isArr) {
				ids = [ids]
			}
			return new Promise((resolve, reject) => {
				let data = { ids }
				this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketUserApi.listByIdsCached', data).then(result => {
					if (result.status) {
						resolve(isArr ? result.data : result.data[0])
					} else {
						this.$message.error('获取处理人姓名失败，失败原因：' + (result.msg || result.message));
						reject()
					}
				}, response => {
					this.$message.error('获取处理人姓名失败，错误码(' + response + ')');
					reject()
				})
			})
		},

		// 修改处理人
		updateHandleUser (val, item) {
			let data = {
				dealUserId: val,
				no: item.orderId
			}
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketApi.updateDealUser', data).then(result => {
				if (result.status) {
					this.$message.success('修改处理人成功');
					this.getProcessingRecords(item)
				} else {
					this.$message.error('修改处理人失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('修改处理人失败，错误码(' + response + ')');
			});
		},

		// 修改状态
		updateTicketStatus (val, item) {
			let data = {
				status: val,
				no: item.orderId
			}
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketApi.updateStatus', data).then(result => {
				if (result.status) {
					this.$message.success('修改工单状态成功');
					this.getProcessingRecords(item)
				} else {
					this.$message.error('修改工单状态失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('修改工单状态失败，错误码(' + response + ')');
			});
		},

		// 回复工单
		replyTicket (item) {
			if (!item.replyContent) {
				this.$message.error('回复内容不能为空')
				return
			}

			let data = {
				orderId: item.orderId,
				'orderRemark.remarkContent': item.replyContent
			}
			this.$axios({
				method: 'post',
				url: API_ROOT.sUrl + '/ticket/v2-workOrder/reply',
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
				},
				data: qs.stringify(data || {})
			}).then(result => {
				if (result.status) {
					this.$message.success('回复成功');
					this.$set(item, 'replyContent', '')
					this.getProcessingRecords(item)
				} else {
					this.$message.error('回复失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('回复失败，错误码(' + response + ')');
			});
		},

		// 获取紧急程度
		getTicketPriority() {
			let data = {
				page: {pageSize: 9999}
			}
			this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketPriorityApi.listCached', data).then(result => {
				if (result.status) {
					this.priorityList = result.data
				} else {
					this.$message.error('获取紧急程度列表失败，失败原因：' + (result.msg || result.message));
				}
			}, response => {
				this.$message.error('获取紧急程度列表失败，错误码(' + response + ')');
			});
		},

		// 获取工单分类
		getTicketTypeList(parentId, obj) {
			let data = {
				parentId: parentId,
				page: {
					pageSize: 9999,
					orderBy: '`index` DESC'
				}
			}

			let qxTicketTypeMap = JSON.parse(localStorage.getItem('qxTicketTypeMap') || '{}')
			let list = qxTicketTypeMap[parentId]
			if (list) {
				if (list.length) {
					obj.children = list
					for (let i = 0; i < obj.children.length; i++) {
						let item = obj.children[i]
						this.getTicketTypeList(item.id, item)
					}
				}
			} else {
				this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketTypeApi.listByParentId', data).then(result => {
					if (result.status) {
						qxTicketTypeMap = JSON.parse(localStorage.getItem('qxTicketTypeMap') || '{}')
						qxTicketTypeMap[parentId] = result.data.list
						localStorage.setItem('qxTicketTypeMap', JSON.stringify(qxTicketTypeMap))
						if (result.data.list.length) {
							obj.children = result.data.list
							for (let i = 0; i < obj.children.length; i++) {
								let item = obj.children[i]
								this.getTicketTypeList(item.id, item)
							}
						}
					} else {
						this.$message.error('获取分类列表失败，失败原因：' + (result.msg || result.message));
					}
				}, response => {
					this.$message.error('获取分类列表失败，错误码(' + response + ')');
				});
			}
		},

		// 显示创建工单弹窗
		showCreateTicketDialog() {
			this.createTicketObj = Object.assign({}, this.$options.data().createTicketObj, {show: true})
			try {
				this.$refs.addFormBox.clearValidate();
			} catch(e) {
			}
		},

		// 创建工单
		createTicket() {
			this.$refs.addFormBox.validate((valid) => {
				if (!valid) return;
				
				let type = this.createTicketObj.type && this.createTicketObj.type.length ? this.createTicketObj.type[this.createTicketObj.type.length - 1] : 90022
				let data = {
					ticket: {
						orderStatus: 2,
						orderContent: this.createTicketObj.orderContent,
						orderType: type,
						orderTitle: 'IM新增工单',
						dealUserId: this.createTicketObj.dealUserId,
						orderPriority: this.createTicketObj.priority,
						attachmentList: [],
						tags: [this.userPhone, this.createTicketObj.orderNo, this.channel, this.createTicketObj.supplier],
						shopId: this.currentShop.id
					},
					tags: [this.userPhone, this.createTicketObj.orderNo, this.channel, this.createTicketObj.supplier],
					templateId: 921,
					properties: {
						channel: this.channel,
						supplier: this.createTicketObj.supplier,
						phone: this.userPhone,
						order_no: this.createTicketObj.orderNo
					}
				}
				this.createTicketObj.loading = true
				this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketApi.saveWorkflowTicket', data).then(result => {
					if (result.status) {
						this.$message.success('操作成功');
						this.createTicketObj.show = false
						this.getTicketList(this.userPhone)
					} else {
						this.createTicketObj.loading = false
						this.$message.error('创建工单失败，失败原因：' + (result.msg || result.message));
					}
				}, response => {
					this.createTicketObj.loading = false
					this.$message.error('创建工单失败，错误码(' + response + ')');
				});
			});
		},

		// 时间字符串格式修改 format="yyyy-MM-dd hh:mm:ss"
		dateFormat(date, format) {
			if (!date) {
				return ''
			} else if (typeof date === 'string') {
				date = new Date(date.replace(/-/g,'/'))
			} else if (typeof date === 'number') {
				date = new Date(date)
			}

			let o = {
				"M+" : date.getMonth() + 1, // month
				"d+" : date.getDate(), // day
				"h+" : date.getHours(), // hour
				"m+" : date.getMinutes(), // minute
				"s+" : date.getSeconds(), // second
				"q+" : Math.floor((date.getMonth() + 3) / 3), // quarter
				"S" : date.getMilliseconds()  // millisecond
			}
		
			if (/(y+)/.test(format)) {  
				format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));  
			}
		
			for (let k in o) {  
				if (new RegExp("(" + k + ")").test(format)) {  
					format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));  
				}
			}
			return format;
		},
	}
}
</script>

<style scoped lang="less">
.list-container {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 1px 0;
}
.add-btn-box {
	padding: 10px;
	box-shadow: 0px 2px 4px #000;
}
.loading {
	pointer-events: none;
}
.section-block {
	font-size: 12px;
	line-height: 18px;
	color: rgb(147, 147, 147);
	border-radius: 10px;
	overflow: hidden;
	margin: 10px;
	&.open {
		.icon-btn {
			transform: rotate(180deg);
		}
		.section-cont {
			display: block;
		}
	}
	&:last-child {
		margin-bottom: 0;
	}
	.section-head {
		position: relative;
		height: 32px;
		padding: 0 10px;
		background: #f5f6f7;
		border-top-right-radius: 10px;
		border-top-left-radius: 10px;
		cursor: pointer;
		color: rgb(102, 102, 102);
		font-weight: 700;
		line-height: 32px;
		.icon-btn {
			position: absolute;
			top: 0;
			right: 10px;
			font-weight: 400;
			line-height: 32px;
		}
	}
	.section-cont {
		display: none;
	}
	.row {
		display: flex;
		padding: 2px 0;
		> .label {
			width: 75px;
			color: rgb(147, 147, 147);
		}
		> .cont {
			flex: 1;
			color: rgb(102, 102, 102);
		}
	}
	.info-box {
		padding: 0 10px 5px;
		background: #f5f6f7;
		border-bottom-right-radius: 10px;
		border-bottom-left-radius: 10px;
		&:before {
			display: block;
			margin-bottom: 5px;
			border-top: 1px solid #ece9e8;
			content: '';
		}
	}
	.flow-box {
		margin-top: 8px;
		margin-bottom: 8px;
		.name {
			font-size: 13px;
			color: rgb(102, 102, 102);
			font-weight: 700;
		}
		.time {
			color: rgb(200, 200, 200);
		}
		.sign {
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			left: 0;
			top: 6px;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			background: #dbdde0;
			color: rgb(102, 102, 102);
			line-height: 1;
		}
		dl {
			position: relative;
			padding-left: 22px;
			padding-bottom: 5px;
			&:before {
				position: absolute;
				left: 8px;
				top: 14px;
				bottom: -8px;
				border-left: 1px solid #dbdde0;
				content: '';
			}
			&:first-child {
				.sign {
					background: #4ea8ff;
					color: #fff;
				}
				&:before {
					border-color: #4ea8ff;
				}
			}
			&:last-child {
				&:before {
					display: none;
				}
			}
		}
		dt {
			padding: 5px 0;
		}
	}
	.reply-box {
		background: #f5f6f7;
		border-radius: 10px;
		padding: 10px;
		.title {
			position: relative;
			top: -5px;
			font-size: 14px;
			color: rgb(102, 102, 102);
			font-weight: 700;
			line-height: 24px;
		}
		.short-form-item {
			display: flex;
			width: calc(50% - 6px);
			/deep/ .el-form-item__label {
				padding: 0;
				white-space: nowrap;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/aside/qxWorkOrder.vue